export default __webpack_public_path__ + "static/media/CA-10 API credentials page.46ea64fc.png";